import { deepFreeze } from '../../util/deepFreeze';
/** Russian translations */
export var russianTranslations = {
    Apr: 'Апр',
    Aug: 'Авг',
    contributions: {
        0: 'контрибуций небыло',
        other: 'контрибуций:'
    },
    Dec: 'Дек',
    Feb: 'Фев',
    Friday: 'Пят',
    hideZero: true,
    Jan: 'Янв',
    Jul: 'Июн',
    Jun: 'Июл',
    Mar: 'Мар',
    May: 'Май',
    Monday: 'Пон',
    Nov: 'Ноя',
    Oct: 'Окт',
    order: 5 /* DATE_TEXT_COUNT */,
    Sep: 'Сеп',
    Wednesday: 'Сре'
};
deepFreeze(russianTranslations);



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/Translate/defaultTranslations/ru.ts
// module id = 27
// module chunks = 0 1